import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import './DashboardPage.css';

const DashboardPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // Close the mobile sidebar whenever the route changes
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  // Lock background scroll when the sidebar is open on mobile
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-layout">
      {/* --- BACKDROP OVERLAY (Mobile) --- */}
      {isSidebarOpen && (
        <div 
          className="dashboard-sidebar-backdrop" 
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      {/* --- SIDEBAR --- */}
      <aside className={`dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        
        {/* Mobile-only header with close button */}
        <div className="dashboard-sidebar-header-mobile">
          <h3>My Dashboard</h3>
          <button 
            type="button" 
            className="dashboard-sidebar-close-btn" 
            onClick={closeSidebar}
            aria-label="Close sidebar"
          >
            &times;
          </button>
        </div>

        <nav>
          <NavLink to="/dashboard/bookings" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-gopuram"></i> My Pooja Bookings
          </NavLink>
          <NavLink to="/dashboard/orders" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-box"></i> My Store Orders
          </NavLink>
          <NavLink to="/dashboard/courses" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-book-open"></i> My Courses
          </NavLink>
          <NavLink to="/dashboard/vastu-consultations" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-drafting-compass"></i> Vastu Consultations
          </NavLink>
          <NavLink to="/dashboard/jaapa-analytics" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-om"></i> Jaapa Analytics
          </NavLink>
          <NavLink to="/dashboard/profile" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-user"></i> My Profile
          </NavLink>
        </nav>
      </aside>

      {/* --- MAIN CONTENT --- */}
      <main className="dashboard-content">
        {/* --- MOBILE-ONLY MENU BUTTON --- */}
        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i> Dashboard Menu
        </button>
        
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardPage;